import Vue from 'vue';
import api from '@/api';
import mutationTypes from '@/store/mutationTypes';
import { handleError, handleSuccess } from '@/store/actions';
import errorCodes from '@/utility/errorCodes';

export default {
  state: {
    smartSearchFilters: [],
    featureTypes: [],
    filterConfig: {
      company: true,
      search: true,
    },
  },

  getters: {
    smartSearchFilters: (state) => state.smartSearchFilters,
    featureTypes: (state) => state.featureTypes,
    smartSearchFiltersConfig: (state) => state.filterConfig,
    numOfActiveSmartSearchFilters: (state) => state.smartSearchFilters.filter(({ active }) => active).length,
  },

  actions: {
    getSmartSearchFilters: ({ commit }, params) => api
      .getSmartSearchFilters(params)
      .then((data) => commit(mutationTypes.SET_SMART_SEARCH_FILTERS, data))
      .catch((err) => handleError({ commit }, err)),

    getSmartSearchFeatureTypes: ({ commit }) => api
      .getSmartSearchFeatureTypes()
      .then((data) => commit(mutationTypes.SET_SMART_SERACH_FEATURE_TYPES, data))
      .catch((err) => handleError({ commit }, err)),

    createSmartSearchFilter: ({
      commit, rootState, dispatch, state,
    }, params) => api
      .createSmartSearchFilter(params)
      .then(async () => {
        await dispatch('getSmartSearchFilters', rootState.filterParams);

        handleSuccess(
          { commit },
          Vue.filter('translate')('smart_search_create_notification_info', { name: params.payload.name }),
        );

        return {
          /** Newly created filter is always put to last position */
          filterId: state.smartSearchFilters.at(-1).id,
        };
      }).catch((err) => {
        handleError(
          { commit },
          err.response.data.code === errorCodes.ER_DUP_ENTRY
            ? Vue.filter('translate')('smart_search_duplicate_name_notification_info', { name: params.payload.name })
            : err,
        );

        return {
          isError: true,
        };
      }),

    editSmartSearchFilter: ({ commit, rootState, dispatch }, params) => api
      .editSmartSearchFilter(params)
      .then(async () => {
        await dispatch('getSmartSearchFilters', rootState.filterParams);

        handleSuccess(
          { commit },
          Vue.filter('translate')('smart_search_edit_notification_info', { name: params.payload.name }),
        );

        return {
          filterId: params.id,
        };
      })
      .catch((err) => {
        handleError(
          { commit },
          err.response.data.code === errorCodes.ER_DUP_ENTRY
            ? Vue.filter('translate')('smart_search_duplicate_name_notification_info', { name: params.payload.name })
            : err,
        );

        return {
          isError: true,
        };
      }),

    deleteSmartSearchFilter: ({ commit, rootState, dispatch }, params) => api
      .deleteSmartSearchFilter(params)
      .then(async () => {
        await dispatch('getSmartSearchFilters', rootState.filterParams);

        handleSuccess(
          { commit },
          Vue.filter('translate')('smart_search_delete_notification_info', {
            name: params.name,
          }),
        );
      })
      .catch((err) => {
        handleError({ commit }, err);
      }),

    updateSmartSearchFiltersOrder: ({ commit }, params) => api
      .updateSmartSearchFiltersOrder(params)
      .catch((err) => {
        handleError({ commit }, err);

        return {
          isError: true,
        };
      }),

    updateSmartSearchFiltersLocally: ({ commit }, data) => commit(mutationTypes.SET_SMART_SEARCH_FILTERS, {
      filters: data,
    }),
  },

  mutations: {
    [mutationTypes.SET_SMART_SEARCH_FILTERS](state, data) {
      state.smartSearchFilters = data.filters;
    },
    [mutationTypes.SET_SMART_SERACH_FEATURE_TYPES](state, data) {
      state.featureTypes = data.filterTypes;
    },
  },
};
